import {SegmentTracker} from '../../../core/SegmentTracker';
import {SegmentInfo} from '../../../types/SegmentInfo';
import * as Utils from '../../../utils/Utils';
import {Bitmovin8PlayerProxy} from '../Bitmovin8PlayerProxy';

import {BITMOVIN8_PLAYER_EVENT} from './Bitmovin8PlayerTypes';

interface DownloadFinishedEvent {
  attempt?: number;
  downloadType?: string;
  httpStatus: number;
  mimeType?: string;
  success: boolean;
  timestamp: number;
  type: string;
  url: string;
}

interface SegmentPlaybackEvent {
  duration?: number;
  mediaInfo?: any;
  mimeType?: string;
  playbackTime?: number;
  representationId?: string;
  timestamp?: number;
  type?: string;
  uid?: string;
  url?: string;
}

export class SegmentTrackerAdapter {
  private segmentTracker: SegmentTracker;

  constructor(player: Bitmovin8PlayerProxy, segmentTracker: SegmentTracker) {
    this.segmentTracker = segmentTracker;

    player.on(BITMOVIN8_PLAYER_EVENT.DownloadFinished, (event) => this.handleOnDownloadFinishEvent(event));
    player.on(BITMOVIN8_PLAYER_EVENT.SegmentPlayback, (event) => this.handleSegmentPlaybackEvent(event));
  }

  getSegmentTracker(): SegmentTracker {
    return this.segmentTracker;
  }

  handleOnDownloadFinishEvent(event: any & DownloadFinishedEvent) {
    if (event.downloadType.indexOf('media/video') === 0) {
      const url = event.url;
      const segment: SegmentInfo = {
        name: Utils.getURLResourceName(url),
        url,
        timestamp: event.timestamp,
      };
      this.segmentTracker.addSegment(segment);
    }
  }

  handleSegmentPlaybackEvent = (event: any & SegmentPlaybackEvent) => {
    this.segmentTracker.removeSegment(event.url);
  };
}
